import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { logoIcons } from '../components/sb-company-logo/sb-company-logo.component';
import { LegalEntityQuery } from '../../pages/admin/state/legal-entities/legal-entity.query';
import {
    LegalTypeEnum,
    LegalEntity
} from '../../pages/admin/state/legal-entities/legal-entity.model';

@Pipe({
    name: 'legalEntityLogo$',
    standalone: true
})
export class LegalEntityLogoPipe implements PipeTransform {
    constructor(private _legalEntityQuery: LegalEntityQuery) {}

    transform(ownerId: LegalEntity['ownerId']): Observable<{
        logoUrl: string;
        website: string;
        icon: logoIcons;
        countryCode: string;
    }> {
        return this._legalEntityQuery.selectOwnerById$(ownerId).pipe(
            map((legalEntity) => {
                let icon: logoIcons = 'COMPANY';
                const thumbnail = {
                    logoUrl: legalEntity?.metadata?.logoUrl,
                    website: legalEntity?.metadata?.website,
                    icon,
                    countryCode: legalEntity.addressCountryCode
                };
                switch (legalEntity?.legalType) {
                    case LegalTypeEnum.PERSON:
                        icon = 'PERSON';
                        return {
                            ...thumbnail,
                            icon
                        };
                    default:
                        return {
                            ...thumbnail,
                            icon
                        };
                }
            })
        );
    }
}
